import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class EmployeeCompetencyLevelService {
  private static competencyLevelMap: Map<string, number> = new Map([
    ["<1", 1],
    ["1-2", 2],
    ["3-4", 3],
    ["5+", 4],
  ]);

  constructor() {}

  public getCompetencyLevel(label: string): number {
    return EmployeeCompetencyLevelService.competencyLevelMap.get(label) ?? 1;
  }

  public getCompetencyLabel(level: number): string {
    for (const [
      key,
      val,
    ] of EmployeeCompetencyLevelService.competencyLevelMap) {
      if (val === level) {
        return key;
      }
    }
    return "<1";
  }

  public getOptions(): string[] {
    return Array.from(EmployeeCompetencyLevelService.competencyLevelMap.keys());
  }

  public getDefaultOption(): string {
    return "<1";
  }

  public getMaxOption(): string {
    return "5+";
  }
}
